import { useEffect, useRef } from "react";
import { useTranslationI18 } from "../../../../services/hooks/useTranslationI18";
import { SearchIcon } from "../../S-Map/Map.icons";
import { SearchCloseIcon } from "./MenuSearchBar.icons";
import styles from "./MenuSearchBar.module.scss";

const SEARCH_GLYPH_SIZE = 50 / 3;

export const MenuSearchBar = (props: {
  expanded: boolean;
  value: string;
  onChange: (value: string) => void;
  onExpand: () => void;
  onCollapse: () => void;
}) => {
  const { expanded, value, onChange, onExpand, onCollapse } = props;
  const { t } = useTranslationI18();
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (expanded) {
      inputRef.current?.focus();
    }
  }, [expanded]);

  return (
    <div
      className={`${styles.search} ${expanded ? styles.expanded : ""}`}
      data-testid={expanded ? "menu-search-bar" : "menu-search-collapsed"}
      data-search-pill=""
    >
      <button
        type="button"
        className={styles.search_toggle}
        onClick={expanded ? undefined : onExpand}
        aria-label={t("common:search")}
        aria-expanded={expanded}
        tabIndex={expanded ? -1 : 0}
        data-testid="menu-search-toggle"
      >
        <SearchIcon size={SEARCH_GLYPH_SIZE} />
      </button>

      {expanded && (
        <>
          <input
            ref={inputRef}
            type="text"
            className={styles.search_input}
            placeholder={t("common:search")}
            value={value}
            onChange={(event) => onChange(event.target.value)}
            data-testid="menu-search-input"
          />
          <div className={styles.search_actions}>
            {!!value && (
              <button
                type="button"
                className={styles.search_clear}
                onClick={() => onChange("")}
                data-testid="menu-search-clear"
              >
                {t("common:clear")}
              </button>
            )}
            <button
              type="button"
              className={styles.search_close}
              onClick={onCollapse}
              aria-label={t("common:cancel")}
              data-testid="menu-search-close"
            >
              <SearchCloseIcon />
            </button>
          </div>
        </>
      )}
    </div>
  );
};
